import { useAuth } from '@/lib/hooks';
import { Button } from '@/components/ui/button';
import { Rocket, Users, TrendingUp, FileText, Building2 } from 'lucide-react';

interface WelcomeStepProps {
  data: any;
  onUpdate: (data: any) => void;
  onNext: () => void;
}

export function WelcomeStep({ onNext }: WelcomeStepProps) {
  const { user } = useAuth();

  return (
    <div className="space-y-6">
      <div className="text-center">
        <h2 className="text-2xl font-bold mb-2">
          Welcome{user?.user_metadata?.full_name ? `, ${user.user_metadata.full_name}` : ''}!
        </h2>
        <p className="text-muted-foreground">
          Let's get your equity management system set up in just a few minutes.
        </p>
      </div>

      <div className="grid gap-4">
        <div className="flex items-start gap-3">
          <div className="p-2 bg-primary/10 rounded-lg">
            <Building2 className="h-5 w-5 text-primary" />
          </div>
          <div>
            <h3 className="font-semibold">Create Your Organization</h3>
            <p className="text-sm text-muted-foreground">
              Set up your company profile and basic information
            </p>
          </div>
        </div>

        <div className="flex items-start gap-3">
          <div className="p-2 bg-primary/10 rounded-lg">
            <Users className="h-5 w-5 text-primary" />
          </div>
          <div>
            <h3 className="font-semibold">Invite Your Team</h3>
            <p className="text-sm text-muted-foreground">
              Add co-founders, employees, and advisors to your equity plan
            </p>
          </div>
        </div>

        <div className="flex items-start gap-3">
          <div className="p-2 bg-primary/10 rounded-lg">
            <Rocket className="h-5 w-5 text-primary" />
          </div>
          <div>
            <h3 className="font-semibold">Create Your First Project</h3>
            <p className="text-sm text-muted-foreground">
              Set up your initial equity pool and vesting schedules
            </p>
          </div>
        </div>

        <div className="flex items-start gap-3">
          <div className="p-2 bg-primary/10 rounded-lg">
            <TrendingUp className="h-5 w-5 text-primary" />
          </div>
          <div>
            <h3 className="font-semibold">Import or Seed Data</h3>
            <p className="text-sm text-muted-foreground">
              Start with sample data or import your existing cap table
            </p>
          </div>
        </div>

        <div className="flex items-start gap-3">
          <div className="p-2 bg-primary/10 rounded-lg">
            <FileText className="h-5 w-5 text-primary" />
          </div>
          <div>
            <h3 className="font-semibold">Review Your Dashboard</h3>
            <p className="text-sm text-muted-foreground">
              See your equity overview and learn about key features
            </p>
          </div>
        </div>
      </div>

      <div className="pt-4">
        <Button onClick={onNext} className="w-full" size="lg">
          Let's Get Started
        </Button>
      </div>
    </div>
  );
}